import posthog from "posthog-js";

export enum PostHostEventsEnum {
  EBOOK_DOWNLOAD = "Baixou Ebook",
  NEWSLETTER_SUBSCRIBED = "Assinou Newsletter",
  WEBINAR_REGISTRATION = "Registrou-se no Webinar",
  LOGIN = "Usuario fez Login",
  USER_EDIT_NAME = "Usuario Atualizou o Nome",
  USER_UPDATE_LOGO = "Alterou Logotipo",
  USER_GENERATE_INTEGRATION_TOKEN = "Gerou um Token de Integração",
  UPDATE_FINANCIAL_ADDRESS = "Alterou Endereço do Financeiro",
  UPDATE_STORE_ADDRESS = "Alterou Endereço da Loja",
  UPDATE_STORE_DATA = "Atualizou Informações da Loja",
  USER_UPDATE_PROFILE_IMAGE = "Alterou Imagem do Perfil",
  USER_SEARCH_HOME_AUTOCOMPLETE = "Pesquisou um Veículo",
  USER_FINANCING_CALCULATOR = "Simulou Financiamento",
  SHARE_VEHICLE = "Compartilhou um Veículo",
  SHARE_BLOG_POST = "Compartilhou um Blog Post",
  SEND_LEAD_WHATSAPP = "Enviou Lead WP",
  SEND_LEAD_MESSAGE = "Enviou Lead Form",
  SEND_CLICK_CALL = "Clicou Ligar",
  LOCATION_EVENT = "Ver Endereço",
  FILTER_EVENT = "Filtrou Veículos",
  SITE_REPORT = "Solicitou Relatório de Site",
}

export type SendPostHotEventType = {
  eventName: PostHostEventsEnum;
  email?: string | null;
  eventProperties?: Record<string, unknown>;
  identifyProperties?: Record<string, unknown>;
};

export const sendPostHogEvent = ({
  eventName,
  eventProperties,
  email,
  identifyProperties = {},
}: SendPostHotEventType): void => {
  if (email) posthog.identify(email, identifyProperties);

  posthog.capture(eventName, eventProperties);
};
